import Skill from "./Skill"
const Skills = () => {
  const skills = [
    {
      title: "Language",
      languages: ["JavaScript", "Java", "Python", "C/C++"],
    },
    {
      title: "Frameworks",
      languages: [
        "React (.js)",
        "Express (.js)",
        "Spring (.java)",
        "Flask (.py)",
      ],
    },
    { title: "Databases", languages: ["MySQL", "MS Server", "Mongo", "Oracle"] },
    {
      title: "DevOps",
      languages: [
        "Git/Github",
        "Docker",
        "Podman",
        "Kubernetes",
        "CI/CD",
      ],
    },
    {
      title: "Frontend Libs",
      languages: ["HTML / CSS ", "Tailwind", "Material UI", "JavaFx", "EJS", "Jinja"],
    },
  ];
  return (
    <>
      <div className="px-5 max-w-[1560px] mx-auto mt-20 py-10 overflow-auto">
        {/* top */}
        <div data-aos="fade-left" className=" mb-10">
          <div className=" text-white w-2/3 font-medium text-[32px] flex items-center gap-2">
            <div className="">
              <span className="text-[#C778DD]">#</span>skills
            </div>
            <div className="line w-1/3 h-px bg-[#C778DD]"></div>
          </div>
        </div>
        {/* bottom */}
        <div className=" flex flex-wrap gap-10 justify-between items-center text-white">
          <div className=" mx-auto flex justify-around md:justify-end flex-wrap w-10/12  gap-4">
            {skills.map(({ title, languages }, index) => {
              return (
                <>
                  {
                    index % 2 === 0 ?
                      <Skill title={title} languages={languages} delay={0} animation={"fade-right"} /> :
                      <Skill title={title} languages={languages} delay={0} animation={"fade-left"} />
                  }
                </>
              );
            })}
          </div>
        </div>
      </div >
    </>
  );
};

export default Skills;
